// import { BrowserMultiFormatReader } from "@zxing/browser";
// import { useRef } from "react";

// export default function ImeiScanner({ onScan, onClose }) {

//   const fileInputRef = useRef(null);
//   const reader = new BrowserMultiFormatReader();

//   const handleImageSelect = async (e) => {

//     const file = e.target.files[0];
//     if (!file) return;

//     const imageUrl = URL.createObjectURL(file);

//     try {
//       const result = await reader.decodeFromImageUrl(imageUrl);
//       console.log("result: ", result);
//       const raw = result.text.trim();
//       const imei = raw.replace(/\D/g, "");

//       if (imei.length >= 14 && imei.length <= 16) {
//         onScan(imei); // ✅ send IMEI to parent
//       } else {
//         alert("Invalid IMEI detected");
//       }

//     } catch (err) {
//       console.error(err);
//       alert("Unable to detect IMEI. Please try again.");
//     } finally {
//       URL.revokeObjectURL(imageUrl);
//     }
//   };

//   return (
//     <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center">
//       <div className="bg-white rounded-xl p-4 w-[320px] text-center">

//         <h3 className="text-sm font-semibold mb-2">
//           Scan IMEI
//         </h3>

//         {/* CAMERA BUTTON */}
//         <label className="block w-full cursor-pointer">

//           <div className="border border-dashed border-slate-300 rounded-lg p-6 text-sm text-slate-600">
//             Tap to open Camera
//           </div>

//           <input
//             ref={fileInputRef}
//             type="file"
//             accept="image/*"
//             capture="environment"
//             onChange={handleImageSelect}
//             hidden
//           />
//         </label>

//         <p className="text-xs text-slate-500 mt-2">
//           Take a photo of IMEI barcode sticker
//         </p>

//         <button
//           onClick={onClose}
//           className="mt-3 w-full py-2 text-sm bg-slate-200 rounded-lg"
//         >
//           Cancel
//         </button>

//       </div>
//     </div>
//   );
// }


// import { Html5Qrcode } from "html5-qrcode";
// import { useEffect, useRef } from "react";

// export default function ImeiScanner({ onScan, onClose }) {
//   const scannerRef = useRef(null);

//   useEffect(() => {
//     const scanner = new Html5Qrcode("imei-scanner");
//     scannerRef.current = scanner;

//     scanner
//       .start(
//         { facingMode: "environment" },
//         {
//           fps: 10,
//           qrbox: { width: 280, height: 120 },
//           experimentalFeatures: {
//             useBarCodeDetectorIfSupported: true,
//           },
//         },
//         (decodedText) => {
//           const imei = decodedText.replace(/\D/g, "");

//           if (imei.length >= 14 && imei.length <= 16) {
//             // ✅ JUST PASS DATA UP
//             onScan(imei);
//           }
//         }
//       )
//       .catch((err) => {
//         console.error("Camera start failed", err);
//       });

//     // ✅ CLEANUP ONLY HERE
//     return () => {
//       if (scannerRef.current) {
//         scannerRef.current
//           .stop()
//           .then(() => scannerRef.current.clear())
//           .catch(() => {});
//       }
//     };
//   }, [onScan]);

//   return (
//     <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center">
//       <div className="bg-white rounded-xl p-4 w-[320px]">
//         <h3 className="text-sm font-semibold mb-2">Scan IMEI</h3>

//         <div id="imei-scanner" />

//         <p className="text-xs text-slate-500 mt-2">
//           Align barcode inside the frame
//         </p>

//         <button
//           onClick={onClose}
//           className="mt-3 w-full py-2 text-sm bg-slate-200 rounded-lg"
//         >
//           Cancel
//         </button>
//       </div>
//     </div>
//   );
// }



import { Html5Qrcode } from "html5-qrcode";
import { useEffect, useRef } from "react";

export default function ImeiScanner({ onScan, onClose }) {
  const html5QrCodeRef = useRef(null);
  const isRunningRef = useRef(false);

  useEffect(() => {
    const html5QrCode = new Html5Qrcode("imei-camera");
    html5QrCodeRef.current = html5QrCode;

    Html5Qrcode.getCameras()
      .then((devices) => {
        if (!devices || devices.length === 0) {
          console.warn("No cameras found");
          return;
        }

        const backCamera =
          devices.find((d) => d.label.toLowerCase().includes("back")) ||
          devices[0];

        html5QrCode
          .start(
            backCamera.id,
            {
              fps: 10,
              qrbox: { width: 250, height: 120 },
              focusMode: "continuous",
            },
            (decodedText) => {
              const imei = decodedText.replace(/\D/g, "");
              if (imei.length >= 14 && imei.length <= 16) {
                onScan(imei);

                if (isRunningRef.current) {
                  html5QrCode.stop().catch(() => {});
                  isRunningRef.current = false;
                }

                onClose();
              }
            }
          )
          .then(() => {
            isRunningRef.current = true; // ✅ mark started
          })
          .catch((err) => {
            console.error("Camera start failed:", err);
          });
      })
      .catch(console.error);

    return () => {
      if (isRunningRef.current) {
        html5QrCode.stop().catch(() => {});
        isRunningRef.current = false;
      }
    };
  }, [onScan, onClose]);

  const handleCancel = () => {
    if (isRunningRef.current && html5QrCodeRef.current) {
      html5QrCodeRef.current.stop().catch(() => {});
      isRunningRef.current = false;
    }
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center">
      <div className="bg-white rounded-xl p-4 w-[320px]">
        <h3 className="text-sm font-semibold mb-2">Scan IMEI</h3>

        <div
          id="imei-camera"
          className="rounded-lg bg-black"
          style={{ width: "100%", height: "250px" }}
        />

        <button
          onClick={handleCancel}
          className="mt-3 w-full py-2 text-sm bg-slate-200 rounded-lg"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}

